import { useState } from "react";
import { Mail, MapPin, Send } from "lucide-react";
import { sendContact } from "../lib/api";
import { toast } from "sonner";

const Contact = () => {
  const [form, setForm] = useState({ name: "", email: "", subject: "", message: "" });
  const [loading, setLoading] = useState(false);

  const update = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await sendContact(form);
      toast.success("Bericht verzonden. We tikken je snel aan.");
      setForm({ name: "", email: "", subject: "", message: "" });
    } catch {
      toast.error("Bericht niet verzonden. Probeer opnieuw.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="contact-page" className="relative">
      <section className="py-20 border-b border-[var(--tha-border)]">
        <div className="mx-auto max-w-7xl px-5 sm:px-8">
          <div className="flex items-center gap-3">
            <span className="h-px w-12 bg-[var(--tha-red)]" />
            <span className="text-xs font-mono-x tracking-[0.3em] text-[var(--tha-red)]">
              CONTACT
            </span>
          </div>
          <h1 className="font-display text-6xl sm:text-8xl mt-5 leading-none">
            TIK ONS <span className="neon-red-text">AAN.</span>
          </h1>
          <p className="mt-6 text-[var(--tha-muted)] max-w-lg">
            Een vraag, een samenwerking, een event of gewoon zin om hi te zeggen? Stuur
            ons een bericht — we lezen alles.
          </p>
        </div>
      </section>

      <section className="py-20">
        <div className="mx-auto max-w-7xl px-5 sm:px-8 grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5">
            <div className="text-xs font-mono-x tracking-[0.3em] text-[var(--tha-muted)]">
              DIRECT CONTACT
            </div>
            <div className="mt-8 space-y-6">
              <div className="flex items-start gap-4 border border-[var(--tha-border)] p-5">
                <Mail size={18} className="text-[var(--tha-red)] mt-1" />
                <div>
                  <div className="font-display text-lg">E-MAIL</div>
                  <a
                    href="mailto:tikhemaannl@gmail.com"
                    className="text-sm text-[var(--tha-muted)] hover:text-white"
                  >
                    tikhemaannl@gmail.com
                  </a>
                </div>
              </div>
              <div className="flex items-start gap-4 border border-[var(--tha-border)] p-5">
                <MapPin size={18} className="text-[var(--tha-red)] mt-1" />
                <div>
                  <div className="font-display text-lg">BASIS</div>
                  <div className="text-sm text-[var(--tha-muted)]">
                    Ergens in Nederland, meestal aan tafel.
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="lg:col-span-7">
            <form
              data-testid="contact-form"
              onSubmit={submit}
              className="border border-[var(--tha-border)] bg-[#0a0a0a] p-6 sm:p-10 space-y-5"
            >
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
                <div>
                  <label className="text-[10px] font-mono-x tracking-widest text-[var(--tha-muted)]">
                    NAAM
                  </label>
                  <input
                    data-testid="contact-name-input"
                    required
                    value={form.name}
                    onChange={update("name")}
                    className="w-full mt-2 px-4 py-3 text-sm"
                    placeholder="Jouw naam"
                  />
                </div>
                <div>
                  <label className="text-[10px] font-mono-x tracking-widest text-[var(--tha-muted)]">
                    E-MAIL
                  </label>
                  <input
                    data-testid="contact-email-input"
                    required
                    type="email"
                    value={form.email}
                    onChange={update("email")}
                    className="w-full mt-2 px-4 py-3 text-sm"
                    placeholder="jouw@email.nl"
                  />
                </div>
              </div>
              <div>
                <label className="text-[10px] font-mono-x tracking-widest text-[var(--tha-muted)]">
                  ONDERWERP
                </label>
                <input
                  data-testid="contact-subject-input"
                  value={form.subject}
                  onChange={update("subject")}
                  className="w-full mt-2 px-4 py-3 text-sm"
                  placeholder="Waar gaat het over?"
                />
              </div>
              <div>
                <label className="text-[10px] font-mono-x tracking-widest text-[var(--tha-muted)]">
                  BERICHT
                </label>
                <textarea
                  data-testid="contact-message-input"
                  required
                  value={form.message}
                  onChange={update("message")}
                  rows={6}
                  className="w-full mt-2 px-4 py-3 text-sm resize-none"
                  placeholder="Schrijf hier je bericht..."
                />
              </div>
              <button
                data-testid="contact-submit-button"
                disabled={loading}
                className="btn-red w-full sm:w-auto px-8 py-4 font-display tracking-wider inline-flex items-center gap-2 disabled:opacity-60"
              >
                <Send size={14} /> {loading ? "VERZENDEN..." : "VERSTUUR BERICHT"}
              </button>
            </form>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;
